import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04359b8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "title" }

import {IconFont} from "@/lib/util";
import BarrageBox from "@/app/editor/modules/basic/v1/preview/BarrageBox.vue";
import ActivityStateBasicStyle from "@/app/editor/modules/basic/v1/preview/ActivityStateBasicStyle.vue";
import BuyBarBasicStyle from "@/app/editor/modules/basic/v1/preview/BuyBarBasicStyle.vue";
import {BasicModuleV1} from "@/app/editor/modules/basic/v1/index";
import {editor} from "@/app/editor";
import {computed, onUnmounted} from "vue";
import ImagePreview from "@/app/editor/views/ImagePreview.vue";
import CountDownBasicStyle from "@/app/editor/modules/basic/v1/preview/CountDownBasicStyle.vue";
import TransactionsView from "@/app/editor/modules/basic/v1/preview/TransactionsView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicStylePreview',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
const basic = editor.activity?.modules[props.index] as BasicModuleV1

const headImg = computed(() => {
  return editor.activity?.images[(editor.activity?.data.themes.find(t => t.theme_id == basic.config.theme.theme_id)?.head_image_template_id ?? '') + 0] ?? {
    imageId: '',
    version: 0,
    src: '',
    code: 0
  }
})

const musicClick = () => {
  if (!basic || basic.config.music_url == '') return
  if (basic.data.audio_status) basic.audio.pause()
  else {
    basic.audio.src = basic.config.music_url
    basic.audio.play()
    basic.audio.loop = true
  }
}

onUnmounted(() => {
  basic.audio.pause()
})


return (_ctx: any,_cache: any) => {
  return (_unref(basic) && _unref(editor).activity)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", {
          class: _normalizeClass(`section_${_ctx.index}`)
        }, null, 2),
        (_unref(basic).config.props.show_barrage)
          ? (_openBlock(), _createBlock(BarrageBox, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(ImagePreview, {
          image: headImg.value,
          height: "auto",
          width: "100%"
        }, null, 8, ["image"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(editor).activity.data.title), 1),
          (_unref(editor).activity?.data.end_at)
            ? (_openBlock(), _createBlock(CountDownBasicStyle, {
                key: 0,
                end: _unref(editor).activity.data.end_at
              }, null, 8, ["end"]))
            : _createCommentVNode("", true),
          _createVNode(ActivityStateBasicStyle, {
            virtual: _unref(basic).config.props.virtual,
            "is-show-statistics": _unref(basic).config.props.show_statistics
          }, null, 8, ["virtual", "is-show-statistics"]),
          (_unref(basic).config.props.is_show_pay_history)
            ? (_openBlock(), _createBlock(TransactionsView, { key: 1 }))
            : _createCommentVNode("", true)
        ]),
        (_unref(basic).config.music_url)
          ? (_openBlock(), _createBlock(_unref(IconFont), {
              key: 1,
              type: "icon-music1",
              class: "music-icon",
              spin: _unref(basic).data.audio_status,
              onClick: musicClick
            }, null, 8, ["spin"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(BuyBarBasicStyle)
      ], 64))
    : _createCommentVNode("", true)
}
}

})